import React from "react";

import { Icon, Tooltip } from "components";

export const InputLabel = ({
  label,
  handleClick = () => {},
  active,
  required,
  tooltip,
  className = "",
  dataTestId,
  id,
}: {
  label?: string | React.ReactNode;
  handleClick?: () => void;
  active?: boolean;
  tooltip?: string;
  required?: boolean;
  className?: string;
  dataTestId?: string;
  id?: string;
}) => (
  <span data-testid={dataTestId} onClick={handleClick} className={`${active ? "floating-label active" : "floating-label"} ${className}`}>
    <span className={required || className?.split(/\s+/).includes("required") ? "required" : ""} id={id}>
      {label}
    </span>

    {tooltip && (
      <span className="input-label-info-icon">
        <Tooltip variant="neutral" title={tooltip}>
          <Icon iconName="tabler/info-circle" size="s" />
        </Tooltip>
      </span>
    )}
  </span>
);
